var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.$router.currentRoute.path ==
      '/' + _vm.role + '/secretariat/internal/letterInfo/' + _vm.$route.params.id
    )?_c('LetterId',{attrs:{"type":'internal'},on:{"save":_vm.save,"removeSave":_vm.removeSave,"archive":_vm.archive,"removeArchive":_vm.removeArchive}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }